<template>
	<ui-box
			v-if="shouldShowSection('advanced') && shouldShowSection('pass_configuration')">
		<h5>Redemption Date Policy</h5>
		<span class="grey--text text--darken-1 text-body-2">
						These are the dates that a pass holder will be able to redeem their pass.
					</span>

		<v-divider class="mb-6 mt-4 opacity-80"></v-divider>

		<v-row>
			<v-col cols="12" sm="6">
				<v-select
						v-model="newPass.redemption_policy.activation_type"
						class="rounded-lg required"
						:items="[{name: 'Upon First Use', value: 'first_use'}, {name: 'Upon Purchase', value: 'immediate'}, {name: 'Specific Date', value: 'date'}]"
						item-text="name"
						label="Start Date"
						outlined
						:rules="rules.redemption_start"
				></v-select>
			</v-col>
			<v-col cols="12" sm="6">
				<v-select
						v-model="selectedRedemptionEnd"
						class="rounded-lg required"
						:items="[{name: 'Duration', value: 'duration'}, {name: 'Specific Date', value: 'date'}]"
						item-text="name"
						label="End Date"
						outlined
						:rules="rules.redemption_end"
				></v-select>
			</v-col>
		</v-row>

		<v-row>
			<v-col cols="12" sm="6"
						 v-if="!newPass.redemption_policy.activation_type"></v-col>

			<!-- Start Date Upon First Use -->
			<v-col cols="12" sm="6"
						 v-if="newPass.redemption_policy.activation_type === 'first_use'">
				<v-radio-group
						v-model="newPass.redemption_policy.expires.type"
						:rules="rules.redemption_start_type"
				>
					<v-row>
						<v-col>
							<v-radio class="caption radio-off"
											 value="days_after_purchase"></v-radio>
						</v-col>
						<v-col>
							<v-text-field
									v-model.number="newPass.redemption_policy.expires.days"
									class="rounded-lg"
									label="Days From Purchase"
									outlined
									persistent-hint
									type="number"
									min="1"
									max="365"
									@focus="newPass.redemption_policy.expires.type = 'days_after_purchase'"
									@wheel.native.prevent
							></v-text-field>
						</v-col>
					</v-row>
					<v-row>
						<v-col>
							<v-radio class="caption radio-off"
											 value="date"></v-radio>
						</v-col>
						<v-col>
							<bw-date-time-picker
									v-model="newPass.redemption_policy.expires.date"
									label="Date"
									@focus="newPass.redemption_policy.expires.type = 'date'"
									withTime
							></bw-date-time-picker>
						</v-col>
					</v-row>
				</v-radio-group>
			</v-col>
			<!-- End: Start Date Upon First Use -->

			<!-- Start Date Upon Purchase -->
			<v-col cols="12" sm="6"
						 v-if="newPass.redemption_policy.activation_type === 'immediate'"></v-col>
			<!-- End: Start Date Upon Purchase -->

			<!-- Start Date Specific Date -->
			<v-col cols="12" sm="6"
						 v-if="newPass.redemption_policy.activation_type === 'date'">
				<bw-date-time-picker
						v-model="newPass.redemption_policy.start_date"
						label="Date"
						:required="true"
						withTime
						:rules="rules.redemption_start_date"
				></bw-date-time-picker>
			</v-col>
			<!-- End: Start Date Specific Date -->


			<v-col cols="12" sm="6" v-if="!selectedRedemptionEnd"></v-col>

			<!-- End Date Duration-->
			<v-col cols="12" sm="6" v-if="selectedRedemptionEnd === 'duration'">
				<v-row>
					<v-col>
						<v-text-field
								v-model="newPass.redemption_policy.ends.amount"
								class="rounded-lg required"
								outlined
								label="Amount"
								persistent-hint
								type="text"
								:rules="rules.redemption_ends_amount"
						></v-text-field>
					</v-col>
					<v-col>
						<v-select
								v-model="newPass.redemption_policy.ends.type"
								class="rounded-lg required"
								outlined
								label="Type"
								persistent-hint
								:items="[{name: 'Years', value: 'years'}, {name: 'Months', value: 'months'}, {name: 'Days', value: 'days'}, {name: 'Hours', value: 'hours'}, {name: 'Minutes', value: 'minutes'}]"
								item-text="name"
								:rules="rules.redemption_ends_type"
						></v-select>
					</v-col>
				</v-row>
			</v-col>
			<!-- End: End Date Duration-->

			<!-- End Date Specific Date -->
			<v-col cols="12" sm="6" v-if="selectedRedemptionEnd === 'date'">
				<bw-date-time-picker
						v-model="newPass.redemption_policy.ends.date"
						label="Date"
						:required="true"
						withTime
						:rules="rules.redemption_ends_date"
				></bw-date-time-picker>
			</v-col>
			<!-- End: End Date Specific Date -->

		</v-row>


	</ui-box>

</template>

<script>
export default {
	name: "PassRedemptionPolicySection",
	props: {
		newPass: {
			type: Object,
			required: true,
		},
		pass: {
			type: Object,
			required: true,
		},
		rules: {
			type: Object,
			required: true,
		},
		showSections: {
			type: Array,
			required: true,
		},
	},
	data() {
		return {
			selectedRedemptionEnd: this.pass?.redemption_policy?.ends?.type
					? (this.pass?.redemption_policy?.ends?.type === 'date' ? 'date' : 'duration')
					: null,
		}
	},
	watch: {
		selectedRedemptionEnd: function (val) {
			if(val && val !== 'duration') {
				this.$set(this.newPass.redemption_policy.ends, 'type', 'date');
			}
		},
	},
	methods: {
		shouldShowSection(section) {
			return !this.showSections.length || this.showSections.includes(section);
		},
	}
}
</script>
